<template>
  <div class="home-content">

    <div class="first-pard">
      <span @click="showLineUser = false" class="back"><img src="@/assets/images/base/icon_righ_g.png" v-show="showLineUser" /></span>
      <div>
        {{ groupInfo.group_name }}
        <span v-if="meOnline >= 1">({{ onlineUserId.length }}/{{ groupUser.length }})</span>
        <span v-if="meOnline < 1" style="color: #f6543e;">You are offline</span>
        <span v-else-if="currentGroupUser.can_speak == 2" style="color: #f6543e;">Has been banned</span>
      </div>
      <div class="chat-more" v-show="!showLineUser" @click="showLineUser = true">
        <img src="@/assets/images/icon/settings_icon_251265.png" />
      </div>
    </div>

    <div class="four-pard" ref="mianscroll">
      <div class="one-box">
        <div class="one-chat" v-if="!!groupInfo.notice">
          <div class="avater"><img src="@/assets/images/avater/0.png" /></div>
          <div class="chat-line">
            <div class="nick-name">Group Announcement</div>
            <div class="chat-box">
              <div class="left yel"></div>
              <div class="message yel">{{ groupInfo.notice }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="one-box" v-for="(item, index) in chats" v-bind:key="index">
        <div class="chat-time" v-if="showTime(item.time, index)">{{ item.time }}</div>
        <div class="one-chat" v-if="item.is_me == 2">
          <div class="avater">
            <a @click="showUserInfo(item.user_id, item.is_master)"><img :src="item.icon" /></a>
          </div>
          <div class="chat-line">
            <div class="nick-name">
              <div class="master" v-if="item.is_master == 1">Lord</div>
              {{ item.nick_name }}
            </div>
            <div class="chat-box">
              <div class="left"></div>
              <div class="message" :class="emojiList.includes(item.message) ? 'emojo' : ''">{{ item.message }}</div>
            </div>
          </div>
        </div>
        <div class="one-chat-my" v-if="item.is_me == 1">
          <div class="chat-line">
            <div class="chat-box">
              <div class="message">
                {{ item.send_to }}
                <span :class="emojiList.includes(item.message) ? 'emojo' : ''">{{ item.message }}</span>
              </div>
              <div class="right"></div>
            </div>
          </div>
          <div class="avater"><a @click="showUserInfo(item.user_id, item.is_master)"><img :src="item.icon" /></a></div>
        </div>
      </div>
    </div>

    <div class="five-pard">
      <div class="send-to">
        <!-- <div class="emojo"><img src="@/assets/images/icon/user_icon_251290.png"></div> -->
        <div @click="showSendUser()">Please select receiver:</div>
        <div class="say-user" @click="showSendUser()">{{ groupOneUserName }}</div>
        <van-picker class="van_picker" toolbar-position="bottom" v-if="showSelectUser" :columns="groupUserNames" confirm-button-text="OK" cancel-button-text="Cancel"
          :default-index="0" show-toolbar title="Please select receiver " @cancel="showSelectUser = false" @confirm="onConfirm" />
      </div>
      <div class="send-box">
        <div class="emojo" @click="showEmojoPage = true"><img src="@/assets/images/icon/smiled_emoji_icon_250933.png">
        </div>
        <input class="say-text" v-model="messageInfo" ref="getfocus" @keyup.enter="insertText" />
        <div class="send" @click="insertText()" v-if="currentGroupUser.can_speak == 1">Send</div>
        <div class="send-no" v-if="currentGroupUser.can_speak == 2">Ban</div>
      </div>
    </div>

    <div class="team-view" v-show="showLineUser">
      <div class="second-pard">
        <ul v-if="currentGroupUser.is_master == 1">
          <li><img src="@/assets/images/user/info/ic_about.png" /></li>
          <li>Edit Group Title</li>
          <li @click="doShowGroupName()"><img src="@/assets/images/base/icon_righ_g.png" /></li>
        </ul>
        <ul v-if="currentGroupUser.is_master == 1">
          <li><img src="@/assets/images/user/info/ic_msg.png" /></li>
          <li>Edit Group Announcement</li>
          <li @click="doShowGroupNotice()"><img src="@/assets/images/base/icon_righ_g.png" /></li>
        </ul>
        <ul>
          <li><img src="@/assets/images/user/info/ic_shield.png" /></li>
          <li>Clear Chat Message</li>
          <li @click="clearRoom()"><img src="@/assets/images/base/icon_righ_g.png" /></li>
        </ul>
      </div>
      <div class="third-pard">
        <div class="title">Group Members({{ onlineUserId.length }}/{{ groupUser.length }})</div>
        <div class="content">
          <div class="oneUser" v-for="(i, index) in groupUser" v-bind:key="index">
            <div class="userInfo" @click="isOption = index">
              <img :src="i.icon" />
              <div class="outline" v-if="!onlineUserId.includes(i.user_id)">
                <div class="status">OFF</div>
                <div class="master" v-if="i.is_master == 1">Lord</div>
                <div :style="i.user_id == userInfo.user_id ? 'color:#f6543e;' : ''">{{ i.name }}</div>
              </div>
              <div class="nosay" v-else-if="i.can_speak == 2">
                <div class="status">BAN</div>
                <div class="master" v-if="i.is_master == 1">Lord</div>
                <div :style="i.user_id == userInfo.user_id ? 'color:#f6543e;' : ''">{{ i.name }}</div>
              </div>
              <div class="online" v-else>
                <div class="status">ON</div>
                <div class="master" v-if="i.is_master == 1">Lord</div>
                <div :style="i.user_id == userInfo.user_id ? 'color:#f6543e;' : ''">{{ i.name }}</div>
              </div>
              <div class="is-me" v-if="i.user_id == userInfo.user_id">Me</div>
            </div>
            <div class="btn-box"
              v-show="isOption == index && currentGroupUser.is_master == 1 && i.is_master == 2 && onlineUserId.includes(i.user_id)">
              <!-- <button class="user-btn" @click="removeFromGroup(i.user_id)">退群</button> -->
              <button class="user-btn" v-if="i.can_speak == 2" @click="setCanSpeak(2, i.user_id)">Lift Speak</button>
              <button class="user-btn" v-if="i.can_speak == 1" @click="setCanSpeak(1, i.user_id)">Ban Speak</button>
              <button class="user-btn" @click="toOutLine(i.user_id)">Take Offline</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="showEmojoPage" position="bottom" closeable close-icon="close">
      <div class="six-pard">
        <div class="emojitem" v-for="item in emojiList" :key="item" @click="addEmoji(item)">{{ item }}</div>
      </div>
    </van-popup>
    <van-popup v-model="showEditGroupName" position="top" closeable close-icon="close">
      <div class="seven-pard">
        <div class="input-title">Please enter group title</div>
        <input class="input-text" type="text" v-model="groupInfo.group_name_x" maxlength="50" />
        <button class="btn-submit" @click="saveGroupInfo(1)">Save</button>
        <div class="errorInfo">{{ errorInfo }}</div>
      </div>
    </van-popup>
    <van-popup v-model="showEditGroupNotice" position="top" closeable close-icon="close">
      <div class="seven-pard">
        <div class="input-title">Please enter group announcement</div>
        <textarea class="input-text" style="height:3rem;" v-model="groupInfo.notice_x" maxlength="300"></textarea>
        <button class="btn-submit" @click="saveGroupInfo(2)">Save</button>
        <div class="errorInfo">{{ errorInfo }}</div>
      </div>
    </van-popup>
    <van-popup v-model="showUserInfoPage" position="top" closeable close-icon="close">
      <div class="eight-pard">
        <!-- 图标, 昵称，手机，邮箱，性别，签名 -->
        <div class="avater">
          <img :class="userBase.is_master == 1 ? 'red-border' : ''" :src="userBase.ico_picture_img" />
        </div>
        <div class="one-line">
          <div>Nickname:</div>
          <div>{{ userBase.nick_name }}</div>
          <button v-clipboard:error="util.onError" v-clipboard:copy="userBase.nick_name"
            v-clipboard:success="util.onCopy">Copy</button>
        </div>
        <div class="one-line">
          <div>Account:</div>
          <div>{{ userBase.phone }}</div>
          <button v-clipboard:error="util.onError" v-clipboard:copy="userBase.phone"
            v-clipboard:success="util.onCopy">Copy</button>
        </div>
        <div class="one-line">
          <div>Email:</div>
          <div>{{ userBase.email }}</div>
          <button v-clipboard:error="util.onError" v-clipboard:copy="userBase.email"
            v-clipboard:success="util.onCopy">Copy</button>
        </div>
        <div class="one-line">
          <div>Gender:</div>
          <div v-if="userInfo.sex == 1">Male</div>
          <div v-if="userInfo.sex == 2">Female</div>
          <div v-if="userInfo.sex == 3">Confidential</div>
        </div>
        <div class="one-line">
          <div>Signature:</div>
          <div>{{ userBase.remark }}</div>
        </div>
      </div>
    </van-popup>

    <FootMenu />
    <van-loading v-show="showloding" size="50px" color="#1989fa" vertical />
  </div>
</template>
<script>
/*global mui*/
import Vue from "vue";
import { Loading } from "vant";
import { Popup } from 'vant';
import { Picker } from 'vant';
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
Vue.use(Popup);
Vue.use(Loading);
Vue.use(Picker);
import FootMenu from "@/coms/footmenu.vue";
import emoji from "@/js/emojiData.json";
export default {
  components: {
    FootMenu
  },
  data() {
    return {
      showloding: false,
      showEmojoPage: false,
      showEditGroupName: false,
      showEditGroupNotice: false,
      showSelectUser: false,
      showUserInfoPage: false,
      emojiList: [],
      messageInfo: "",
      userInfo: this.util.user,
      userBase: {},
      groupId: 0,
      groupInfo: {group_name_x:'',notice_x:''},
      groupUser: [],
      currentGroupUser: {},
      chats: [],
      currentTime: this.util.getCurrentTime()[0],
      showLineUser: false,
      isOption: 1,
      onlineUserId: [],
      groupUserNames: [],
      groupOneUserName: "Everyone",
      groupSelectList: [],
      groupOneSelectUser: { user_id: 0, nick_name: "Everyone" },
      errorInfo: "",
      meOnline: 3,
      noticeKey: ['#can_speak#', '#remove_group#', '#edit_notice#'],
    };
  },
  methods: {
    doShowGroupName(){
      this.showEditGroupName = true;
      this.groupInfo['group_name_x'] = this.groupInfo['group_name'];
    },
    doShowGroupNotice(){
      this.showEditGroupNotice = true;
      this.groupInfo['notice_x'] = this.groupInfo['notice'];
    },
    onConfirm(value, index) {
      this.groupOneSelectUser = this.groupSelectList[index];
      this.groupOneUserName = value;
      this.showSelectUser = false;
    },
    saveGroupInfo(type) {
      if (!this.groupInfo.group_name_x && type == 1) {
        this.errorInfo = "Title cannot be empty";
      } else if (!this.groupInfo.notice_x && type == 2) {
        this.errorInfo = "Announcement cannot be empty";
      } else {
        this.errorInfo = "Saving..";
        let params = {
          type: type,
          groupId: this.groupId,
          groupNameOrNotice: type == 1 ? this.groupInfo.group_name_x : this.groupInfo.notice_x
        };
        this.util.setDnValueToken(params);
        this.axios.post(this.api.api_modifyGroupNameOrNotice, this.util.encodeSearchParams(params)).then(res => {
          this.showloding = false;
          if (res.data.code == 0) {
            this.sendMessage("#edit_notice#");
            this.errorInfo = "Modification succeeded";
          } else {
            this.errorInfo = res.data.message;
          }
          setTimeout(() => {
            this.errorInfo = "";
            this.showEditGroupName = false;
            this.showEditGroupNotice = false;
          }, 1000)
        })
          .catch(() => {
            this.showloding = false;
            this.errorInfo = "Modification failed";
          });
      }
    },
    setCanSpeak(can_speak, userId) {
      let params = { groupId: this.groupId, opUserId: userId };
      this.util.setDnValueToken(params);
      this.axios.post(this.api.api_openCloseGroupSpeak, this.util.encodeSearchParams(params)).then(res => {
        this.showloding = false;
        if (res.data.code == 0) {
          mui.alert(can_speak == 1 ? "Banned successfully" : "Successfully lifted the ban");
          this.getGroupUser();
          this.sendMessage("#can_speak#");
        } else {
          mui.alert(res.data.message);
        }
      })
        .catch(() => {
          this.showloding = false;
        });
    },
    removeFromGroup(userId) {
      let _this = this;
      mui.confirm("Are you sure to let him quit the group?", "Hint", ["No", "Yes"], function (e) {
        if (e.index == 1) {
          let params = { groupId: _this.groupId, opUserId: userId };
          _this.util.setDnValueToken(params);
          this.axios.post(this.api.api_openCloseGroupSpeak, this.util.encodeSearchParams(params)).then(res => {
            this.showloding = false;
            if (res.data.code == 0) {
              mui.alert("Exit the group successfully.");
              this.getGroupUser();
              this.sendMessage("#remove_group#");
              setTimeout(() => {
                this.sendEx(4, { groupId: this.groupId, user_id: userId });
              }, 1000);
            } else {
              mui.alert(res.data.message);
            }
          })
            .catch(() => {
              this.showloding = false;
            });
        } else {
          mui.confirm();
        }
      });
    },
    clearRoom() {
      let _this = this;
      mui.confirm("Are you sure you want to clear the chat room?", "Hint", ["No", "Yes"], function (e) {
        if (e.index == 1) {
          localStorage.removeItem("chat_" + _this.userInfo.user_id);
          _this.showLineUser = false;
          _this.chats = [];
        } else {
          mui.confirm();
        }
      });
    },
    getChats() {
      this.chats = [];
      let localChat = localStorage.getItem("chat_" + this.userInfo.user_id);
      if (localChat != null && this.chats.length == 0) {
        this.chats = JSON.parse(localChat);
      }
    },
    showUserInfo(user_id, is_master) {
      if (!user_id) {
        mui.toast("Loss of user _ ID data");
        return;
      }
      if (this.userInfo.user_id == user_id) {
        this.userBase = this.userInfo;
        this.userBase['is_master'] = is_master;
        this.showUserInfoPage = true;
      } else {
        this.showloding = true;
        this.userBase = {};
        let params = { otherUserId: user_id };
        this.util.setDnValueUser(params);
        this.axios.get(this.api.api_getOtherUserByUserId, { params: params }).then(res => {
          this.showloding = false;
          if (res.data.code == 0) {
            this.showloding = false;
            this.showUserInfoPage = true;
            this.userBase = res.data.data;
            this.userBase['ico_picture_img'] = require('@/assets/images/avater/' + res.data.data.ico_picture + '.png');
            this.userBase['is_master'] = is_master;
          } else {
            this.util.checkToken(res.data.message);
          }
        }).catch(() => {
          this.showloding = false;
          mui.toast("Interface exception")
        });
      }
    },
    showSendUser() {
      this.showSelectUser = true;
    },
    showTime(time, index) {
      if (index == 0 || (index > 0 && time != this.chats[index - 1].time)) return true;
      return false;
    },
    //选择表情发送
    addEmoji(s) {
      this.showEmojoPage = false;
      this.showloding = true;
      this.getOneGroupUserByUserId((g) => {
        if (g.can_speak == 2) {
          mui.alert("Failed to send, you have been banned");
          return;
        }
        this.sendMessage(s);
        this.showloding = false;
        this.bottomScrollClick();
      })
    },
    //输入消息发送
    insertText() {
      this.messageInfo = this.messageInfo.trim();
      if (this.messageInfo != '') {
        let info = this.messageInfo;
        this.messageInfo = "";
        this.showloding = true;
        this.getOneGroupUserByUserId((g) => {
          if (g.can_speak == 2) {
            mui.alert("Failed to send, you have been banned");
            return;
          }
          this.sendMessage(info);
          this.showloding = false;
          this.bottomScrollClick();
        })
      }
      this.$nextTick(() => {
        this.$refs.getfocus.focus();
      })
    },
    topScrollClick() {
      this.$nextTick(() => {
        let scrollEl = this.$refs.mianscroll;
        scrollEl.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    bottomScrollClick() {
      this.$nextTick(() => {
        let scrollEl = this.$refs.mianscroll;
        scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: 'smooth' });
      });
    },
    toOutLine(user_id) {
      this.sendEx(4, { groupId: this.groupId, user_id: user_id });
      mui.toast("Take user offline success");
      this.sendEx(6, { groupId: this.groupId });
    },
    sendMessage(m) {
      this.currentTime = this.util.getCurrentTime()[0];
      if (!this.groupOneSelectUser) this.groupOneSelectUser = { user_id: 0, nick_name: "Everyone" };
      let messages = {
        groupId: this.groupId,
        time: this.currentTime,
        user_id: this.userInfo.user_id,
        nick_name: this.userInfo.nick_name + '(' + this.userInfo.login_name + ')',
        send_user: this.userInfo.ico_picture
          + ',' + this.currentGroupUser.is_master
          + ',' + this.userInfo.user_id
          + ',' + this.userInfo.nick_name + '(' + this.userInfo.login_name + ')',
        is_master: this.currentGroupUser.is_master,
        is_me: 1,
        icon: this.userInfo.ico_picture_img,
        message: m,
        send_to: "@" + this.groupOneSelectUser.nick_name + "：",
      }

      if (this.meOnline < 1) {
        mui.alert("Failed to send, you have been offline");
        return;
      }
      if (this.currentGroupUser.can_speak == 2) {
        mui.alert("Failed to send, you have been banned");
        return;
      }
      // if (this.onlineUserId.length == 1) {
      //   mui.alert("Failed to send. No user is currently online");
      //   return;
      // }
      if (this.groupOneSelectUser.user_id == 0 || this.noticeKey.includes(m)) {
        this.sendEx(1, messages);
      } else {
        if (!this.onlineUserId.includes(this.groupOneSelectUser.user_id)) {
          mui.alert("Failed to send. The person you sent to is not online.");
          return;
        }
        this.sendEx(2, messages);
      }
      if (!this.noticeKey.includes(m)) {
        this.chats = this.chats.concat(messages);
        localStorage.setItem("chat_" + this.userInfo.user_id, JSON.stringify(this.chats));
      }
    },
    /*global appendTxt,sendMsgToGroup,sendMsgToOne,stopOne,getOnline,sendPicToOne,sendPicToGroup,stopGroup,openws*/
    sendEx(v, msg) {
      msg.groupId = 100000 + msg.groupId;
      if (v == 1) sendMsgToGroup(msg.send_user, msg.message, msg.groupId);
      else if (v == 2) sendMsgToOne(msg.send_user, msg.message, msg.groupId + "_" + this.groupOneSelectUser.user_id);
      else if (v == 4) stopOne(msg.groupId + "_" + msg.user_id);
      else if (v == 6) getOnline(msg.groupId);
      else if (v == 7) sendPicToOne(msg.send_user, msg.message, msg.groupId + "_" + this.groupOneSelectUser.user_id);
      else if (v == 9) sendPicToGroup(msg.send_user, msg.message, msg.groupId);
      else if (v == 10) stopGroup(msg.groupId);
    },
    handleMsg(message) {
      let msg = JSON.parse(message);
      // if (msg.type != 3) console.log(msg);

      if (msg.type == 1) { //接收消息
        if (msg.info == "#can_speak#") {
          if (this.currentGroupUser.can_speak == 1) mui.toast("You have been banned");
          if (this.currentGroupUser.can_speak == 2) mui.toast("The ban has been lifted");
          this.getGroupUser();
          return;
        }
        if (msg.info == "#remove_group#") {
          if (this.currentGroupUser.can_speak == 1) mui.toast("You are kicked out from chat group");
          this.getGroupUser();
          return;
        }
        if (msg.info == "#edit_notice#") {
          this.getOneGroup();
          return;
        }
        let send_user = msg.sender.split(',');
        let user_id = send_user[2];
        let nick_name = send_user[3];
        let messages = {
          user_id: user_id,
          groupId: this.groupId,
          time: this.currentTime,
          id: 4,
          nick_name: nick_name,
          is_master: parseInt(send_user[1]),
          is_me: 2,
          icon: require('@/assets/images/avater/' + send_user[0] + '.png'),
          message: msg.info,
        }
        if (user_id != this.userInfo.user_id) {
          this.chats = this.chats.concat(messages);
          localStorage.setItem("chat_" + this.userInfo.user_id, JSON.stringify(this.chats));
        }
        this.bottomScrollClick();
        appendTxt("News:" + JSON.stringify(msg));
        return;
      }
      if (msg.type == 2) { //接收表情
        appendTxt("Icon:" + JSON.stringify(msg));
        return;
      }
      if (msg.type == 3) { //统计在线
        let has = this.onlinePerson;
        if (msg.count != has) this.getGroupUser();
        this.onlinePerson = msg.count;
        let onlineUserId = [];
        msg.infos.forEach(function (item) {
          let id = item.userId.split('_')[1];
          onlineUserId.push(parseInt(id));
        });
        this.onlineUserId = onlineUserId;
        this.meOnline = 3;
        appendTxt("Online:" + JSON.stringify(msg));
        return;
      }
      if (msg.type == 5) { //异常处理
        appendTxt("Abnormal:" + JSON.stringify(msg));
        return;
      }
    },
    getOneGroupUserByUserId(callback) {
      let params = {}
      this.util.setDnValueUser(params);
      this.axios.get(this.api.api_getOneGroupUserByUserId, { params: params }).then(res => {
        this.showloding = false;
        if (res.data.code == 0) {
          // console.log("api_getOneGroupUserByUserId");
          // console.log(res.data.data)
          if (typeof callback == "function") {
            callback(res.data.data);
          }
        } else {
          this.util.checkToken(res.data.message);
        }
      });
    },
    getOneGroup() {
      let params = { groupId: this.groupId }
      this.util.setDnValueToken(params);
      this.axios.get(this.api.api_getOneGroup, { params: params }).then(res => {
        this.showloding = false;
        if (res.data.code == 0) {
          // console.log("api_getOneGroup");
          // console.log(res.data.data);
          this.groupInfo = res.data.data;
        } else {
          this.util.checkToken(res.data.message);
        }
      });
    },
    getGroupUser() {
      let params = { groupId: this.groupId }
      this.util.setDnValueToken(params);
      params['type'] = 1;
      this.axios.get(this.api.api_getGroupUser, { params: params }).then(res => {
        this.showloding = false;
        if (res.data.code == 0) {
          // console.log("api_getGroupUser");
          // console.log(res.data.data);
          let groupUser = res.data.data.map(item => {
            return {
              id: item.id,
              is_master: item.is_master,
              name: item.nick_name + "(" + item.login_name + ")",
              icon: require('@/assets/images/avater/' + item.ico_picture + '.png'),
              can_speak: item.can_speak,
              user_id: item.user_id,
              nick_name: item.nick_name,
            }
          });
          this.groupUser = groupUser;
          // console.log(groupUser);
          this.groupUserNames = [];
          this.groupSelectList = [];
          this.groupUserNames.push("Everyone");
          this.groupSelectList.push({ user_id: 0, nick_name: "Everyone" });
          res.data.data.forEach((item) => {
            let one = item.nick_name;
            if (this.currentGroupUser.is_master == 1 && this.onlineUserId.includes(item.user_id) && item.user_id != this.userInfo.user_id) {
              if (item.is_master == 1) one += "(Lord)";
              this.groupUserNames.push(one);
              this.groupSelectList.push({ user_id: item.user_id, nick_name: one });
            } else if (this.currentGroupUser.is_master == 2 && item.is_master == 1) {
              one += "(Lord)";
              this.groupUserNames.push(one);
              this.groupSelectList.push({ user_id: item.user_id, nick_name: one });
            }
            if (item.user_id == this.userInfo.user_id) {
              this.currentGroupUser.can_speak = item.can_speak;
            }
          })
        } else {
          this.util.checkToken(res.data.message);
        }
      });
    },
    refreshOnline() {
      this.util.timeOut4 = setTimeout(() => {
        this.sendEx(6, { groupId: this.groupId });
        if (this.meOnline > 0) this.meOnline--;
        else {
          let myId = this.userInfo.user_id;
          this.onlineUserId = this.onlineUserId.filter(item => item != myId);
        }
        if (this.util.isLogin()) this.refreshOnline();
      }, 1000);
    },
    initPage() {
      this.util.refreshUserInfo((res) => {
        this.userInfo = res;
        this.getChats();
        this.bottomScrollClick();
        this.getOneGroupUserByUserId((g) => {
          if (g == null) mui.alert("You are not a member of this chat group");
          else {
            this.groupId = g.group_id;
            this.currentGroupUser.is_master = g.is_master;
            this.currentGroupUser.can_speak = g.can_speak;
            let groupUserId = 100000 + this.groupId + "_" + this.userInfo.user_id;
            openws(groupUserId);
            localStorage.setItem("groupUserId", groupUserId);
            mui.toast("You are online successfully");
            //console.log(groupUserId + "Go online");
            this.getOneGroup();
            this.onlinePerson = 0;
            this.onConfirm("Everyone", 0)
            this.getGroupUser();
            this.refreshOnline();
          }
        });
      });
    }
  },
  activated() {
    if (this.util.isLogin()) { this.initPage(); }
  },
  created() {
    this.emojiList = emoji;
  },
  mounted() {
    window.handleMsg = this.handleMsg;
  }
};
</script>
<style lang="scss" scoped>
.home-content {
  font-size: 0.32rem;
  background: rgb(235, 235, 235);
  color: rgb(103, 103, 103);
  width: 100%;
  height: 100%;

  .van_picker {
    background-color: rgb(164, 194, 219);
    width: 100%;
    position: absolute;
    z-index: 10;
    left: 0;
    right: 0;
    bottom: 50px;
    border-radius: 10px/10px;
  }

  .first-pard {
    height: 36px;
    display: grid;
    grid-template-columns: 10% 1fr 10%;
    align-items: center;
    text-align: center;
    font-size: 0.36rem;
    font-weight: bold;
    color: black;

    .back {
      cursor: pointer;

      img {
        display: block;
        margin-left: 5%;
        width: 0.5rem;
        transform: rotate(180deg);
      }
    }

    .chat-more {
      img {
        display: block;
        margin-left: 5%;
        width: 0.6rem;
      }
    }
  }

  .team-view {
    background: white;
    position: absolute;
    z-index: 4;
    top: 35px;
    bottom: 0;
    left: 0;
    right: 0;

    .second-pard {


      ul {
        display: flex;
        align-items: center;
        border-bottom: 1px solid rgb(238, 238, 238);
        cursor: pointer;
        margin: auto;

        li {
          display: flex;
          align-items: center;
          height: 1.2rem;
        }

        :nth-child(1) img {
          // display: block;
          margin: auto 0.3rem;
          width: 0.9rem;
          height: 0.9rem;
        }

        :nth-child(3) {
          display: flex;
          justify-content: flex-end;
          margin-left: auto;
          margin-right: 0.4rem;

          img {
            display: block;
            width: 0.46rem;
          }
        }
      }
    }

    .third-pard {
      background-color: white;
      margin: auto;
      width: 100%;
      border-radius: 5px;

      .title {
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .content {
        width: 100%;
        color: rgb(149, 149, 149);

        .oneUser {
          width: 100%;

          .userInfo {
            display: flex;
            align-items: center;
            border-top: 1px solid rgb(238, 238, 238);

            .master {
              color: white;
              background: rgb(182, 171, 27);
              padding: 0 6px;
              font-weight: bold;
              margin-right: 8px;
              border-radius: 4px;
            }

            img {
              border-radius: 50%;
              display: block;
              width: 40px;
              height: 40px;
              margin: 4px 10px;
            }

            .online {
              color: rgb(3, 207, 40);
              display: flex;
              align-items: center;

              .status {
                color: white;
                background: rgb(3, 207, 40);
                padding: 0 6px;
                font-weight: bold;
                margin-right: 8px;
                border-radius: 10px;
              }

            }

            .outline {
              display: flex;
              align-items: center;

              .status {
                color: white;
                background: rgb(98, 98, 98);
                padding: 0 6px;
                font-weight: bold;
                margin-right: 8px;
                border-radius: 10px;
              }
            }

            .nosay {
              color: #f6543e;
              display: flex;
              align-items: center;

              .status {
                color: white;
                background: #f6543e;
                padding: 0 6px;
                font-weight: bold;
                margin-right: 8px;
                border-radius: 10px;
              }
            }

            .is-me {
              margin-left: auto;
              padding-right: 20px;
              color: #f6543e;
            }
          }

          .btn-box {
            display: flex;
            align-items: center;
            height: 50px;
            padding: 0 5px;

            .user-btn {
              border-radius: 5px/5px;
              margin: 2px 5px;
              padding: 4px 0;
              width: 85px;
              background: #628808;
              color: white;
            }
          }
        }
      }
    }
  }

  .four-pard {
    width: 100%;
    margin: auto;
    padding-bottom: 230px;
    height: 100%;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    background: rgb(241, 241, 241);

    .emojo {
      font-size: 26px !important;
    }

    .one-box {
      color: black;
      margin: auto;
      width: 94%;

      .chat-time {
        margin: auto;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .one-chat {
        display: flex;

        .avater {
          padding-right: 6px;

          img {
            border: 1.5px solid rgba(7, 102, 245, 0.4);
            border-radius: 10%;
            width: 46px;
            display: block;
          }
        }

        .chat-line {
          padding-bottom: 10px;

          .nick-name {
            display: flex;
            align-items: center;
            padding-left: 10px;

            .master {
              color: white;
              background: rgb(182, 171, 27);
              padding: 0 6px;
              font-weight: bold;
              margin-right: 8px;
              border-radius: 4px;
            }
          }

          .chat-box {
            display: -webkit-box;
            padding: 4px 0;
            width: 100%;

            .left {
              width: 8px;
              height: 8px;
              margin-top: 14px;
              margin-right: -4px;
              background-color: white;
              transform: rotate(45deg);
            }

            .message {
              max-width: 100%;
              font-size: 0.34rem;
              border-radius: 5px;
              background-color: white;
              padding: 8px;
              word-break: break-all;
            }
          }

          .yel {
            background-color: yellow !important;
          }
        }
      }

      .one-chat-my {
        display: flex;
        justify-content: flex-end;
        color: black;

        .avater {
          padding-left: 6px;

          img {
            border: 1.5px solid rgba(7, 102, 245, 0.4);
            border-radius: 10%;
            width: 46px;
            display: block;
          }
        }

        .chat-box {
          display: flex;
          justify-content: flex-end;
          padding-top: 4px;
          padding-bottom: 14px;

          .right {
            width: 8px;
            height: 8px;
            margin-top: 14px;
            background-color: rgb(149 236 105);
            transform: rotate(45deg);
          }

          .message {
            width: 100%;
            font-size: 0.34rem;
            margin-right: -4px;
            border-radius: 5px;
            background-color: rgb(149 236 105);
            padding: 8px;
            word-break: break-all;
          }
        }
      }
    }

  }

  .five-pard {
    position: absolute;
    background: rgb(235, 235, 235);
    left: 0;
    bottom: 1.2rem;
    right: 0;
    z-index: 3;

    .send-to {
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: -5px;

      .say-user {
        font-size: 0.32rem;
        padding: 3px;
      }
    }

    .send-box {
      height: 50px;
      display: grid;
      justify-items: center;
      align-items: center;
      grid-template-columns: 40px 1fr 70px;

      .emojo {
        img {
          display: block;
          width: 30px;
          height: 30px;
        }
      }

      .say-text {
        font-size: 0.36rem;
        padding-left: 5px;
        width: 100%;
        height: 40px;
        border-radius: 5px;
      }

      .send {
        color: white;
        border-radius: 4px;
        padding: 6px 14px;
        background: #628808;
      }

      .send-no {
        color: white;
        border-radius: 4px;
        padding: 6px 14px;
        background: rgb(204, 204, 204);
      }
    }
  }

  .six-pard {
    width: 98%;
    background: white;
    margin: auto;
    padding: 5px 8px;
    border-radius: 10px/10px;
    display: flex;
    justify-content: left;
    flex-wrap: wrap;

    .emojitem {
      width: 10%;
      height: 40px;
      text-align: center;
      line-height: 40px;
      font-size: 30px;
    }
  }

  .seven-pard {
    width: 98%;
    margin: 20px auto;
    padding: 5px 5px;
    border-radius: 10px/10px;

    .input-title {
      font-weight: bold;
      padding-left: 5px;
      color: black;
    }

    .input-text {
      width: 98%;
      height: 1rem;
      border-radius: 5px/5px;
      color: black;
      border: 1px solid rgb(232, 234, 237);
      margin: 5px 2px;
      padding: 0 10px;
    }

    .btn-submit {
      margin: 5px auto;
      width: 100%;
      border-radius: 4px;
      font-size: 0.34rem;
      height: 40px;
      background: #628808;
      color: white;
    }

    .errorInfo {
      text-align: center;
      color: #f6543e;
    }

  }

  .eight-pard {
    width: 98%;
    margin-top: 20px;
    padding: 10px 20px;
    border-radius: 10px/10px;

    .one-line {
      display: grid;
      grid-template-columns: 110px 1fr 18px;

      button {
        margin-left: auto;
        color: brown;
        float: right;
      }
    }

    .avater {
      margin-top: 0.35rem;
      margin-bottom: 0.2rem;
      font-weight: bold;
      text-align: center;
      color: brown;

      img {
        border-radius: 100%;
        border: 0.08rem solid #628808;
        display: block;
        margin: auto;
        width: 2.6rem;
      }

      .red-border {
        border: 0.08rem solid #f6543e;
      }
    }
  }
}
</style>  